import { useState } from 'react';

import { getPrimeTrial } from '@services/api/stock/prime';
import { getBannerInfoProfile, getStockSRE } from '@services/api/stock/profile';
import { errorLogger } from '@ajaibid/utils';
import { useSelector } from 'react-redux';
import NO_PROFILE from 'Icon/MenuProfile/icon_no_profile.png';

const useStockProfile = () => {
  const [sreData, setSREData] = useState({});
  const [bannerProfile, setBannerProfile] = useState([]);
  const [primeTrialData, setPrimeTrialData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const homeData = useSelector((state) => state.auth.homeData);
  const buyingPowerStock = useSelector(
    (state) => state.profile?.profileTradeData?.result?.trading_limit || 0
  );
  const isErrorFetchBPStock = useSelector((state) => !!state.profile?.profileTradeError);
  const isPremium = homeData?.membership_tier === 'PREMIUM';
  const isPremiumTrial = homeData?.membership_tier === 'PRIME_TRIAL';
  const userPhoto = homeData?.user_photo;
  const imgProfile = userPhoto || NO_PROFILE;

  const fetchStockSRE = async () => {
    setIsLoading(true);
    try {
      const response = await getStockSRE();
      setSREData(response.result);
    } catch (err) {
      errorLogger('ERROR_API', err.message, { function: 'fetchStockSRE' });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStockBannerProfile = async () => {
    setIsLoading(true);
    try {
      const response = await getBannerInfoProfile();
      setBannerProfile(response);
    } catch (err) {
      errorLogger('ERROR_API', err.message, { function: 'fetchStockBannerProfile' });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPrimeTrial = async () => {
    setIsLoading(true);
    try {
      const response = await getPrimeTrial();
      if (response) {
        setPrimeTrialData(response.result);
      }
    } catch (err) {
      errorLogger('ERROR_API', err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    sreData,
    fetchStockSRE,
    fetchPrimeTrial,
    fetchStockBannerProfile,
    primeTrialData,
    isPremium,
    isPremiumTrial,
    userPhoto,
    imgProfile,
    buyingPowerStock,
    isErrorFetchBPStock,
    bannerProfile,
  };
};

export default useStockProfile;
